import { ConfirmationModal, ExchangeIcon, Flex, Text, useOpenModal } from '@modusign/design-system';
import { useState } from 'react';

import UploadModal from '@app/components/Modal/UploadModal';
import LoadingProgressBar from '@app/components/Modal/UploadModal/LoadingProgressBar';
import useTemplateDocumentFileUpload from '@app/hooks/documentSetup/useTemplateDocumentFileUpload';
import pushDataLayer from '@app/libs/analytics/googleTagManager';
import getExtensionFromFileName from '@app/libs/file/getExtensionFromFileName';

function ExchangeDocumentFileButton() {
  const openModal = useOpenModal();

  const { isLoading, mutate: uploadDocumentFile } =
    useTemplateDocumentFileUpload('templateFileChange');
  const [fileName, setFileName] = useState<string | null>(null);

  const handleOpenConfirmModal = () => {
    openModal(({ isOpen, onClose }) => (
      <ConfirmationModal
        confirmButtonLabel="파일 교체"
        isOpen={isOpen}
        maxWidth="xxs"
        title="문서 파일 교체"
        variant="warning"
        onAfterOpen={() => {
          pushDataLayer({
            event: 'showTemplateFileChangeModal',
          });
        }}
        onClose={onClose}
        onConfirm={() => {
          pushDataLayer({
            event: 'confirmTemplateFileChangeModal',
          });
          onClose();
          handleOpenUploadModal();
        }}
      >
        <Text as="p" textAlign="center">
          사인·도장·입력란 위치가 변경 또는 노출되지 않을 수 있으니 수정 후 이용해 주세요.
        </Text>
      </ConfirmationModal>
    ));
  };

  const handleOpenUploadModal = () => {
    openModal(({ isOpen, onClose }) => (
      <UploadModal
        isOpen={isOpen}
        needDraft={false}
        needTemplate={false}
        onClose={onClose}
        onSubmit={(file) => {
          setFileName(file.name);
          uploadDocumentFile(file);
          pushDataLayer({
            event: 'submitTemplateFileUploadModal',
          });
          onClose();
        }}
      />
    ));
  };

  return (
    <>
      <Flex
        as="button"
        gap={2}
        p={2}
        sx={{
          color: 'textNeutralUltraLight',
          '&:hover': {
            color: 'textNeutralLightest',
          },
          alignItems: 'center',
        }}
        onClick={handleOpenConfirmModal}
      >
        <ExchangeIcon />
        <Text fontWeight="medium">문서 파일 교체</Text>
      </Flex>
      <LoadingProgressBar
        extension={fileName ? getExtensionFromFileName(fileName) : null}
        isLoading={isLoading}
      />
    </>
  );
}

export default ExchangeDocumentFileButton;
